module.exports = __webpack_public_path__ + "img/istanbul-basaksehir.1b4bfd6d.png";